"use client";
import { useEffect, useState } from "react";
import { CrossIcon, CopyIcon, ClockRewind, ShareIcon } from "./icons";
import { Ban, RefreshCw, ChevronsLeft, ChevronsRight } from "lucide-react";
import BuyCreditsModal from "./BuyCreditsModal";
import type { UserDetail } from "@/types";
import { useDispatch, useSelector } from "react-redux";
import {setActiveNavItem, setActiveItem
} from "@/store/mainSlice";

type GenerateLinkResponse = {
  createdAt: string;
  expiresAt: string;
  shareToken: string;
  _id: string;
  status: string;
  noOfHits?: number;
};
interface ShareLinkPopupProps {
  open: boolean;
  onClose: () => void;
  // isFreeLimit?: boolean | "true" | "false";
  generateData: {
    websiteUrl: string;
    screenId: string;
    websiteDetailsUid: string;
    userId: string;
  };
  userDetail?: UserDetail;
  htmlContent?: string;
  isWebsiteHistoryPage: boolean;
}
export function ShareLinkPopup({
  open,
  onClose,
  // isFreeLimit,
  generateData,
  userDetail,
  htmlContent,
  isWebsiteHistoryPage,
}: ShareLinkPopupProps) {
  // console.log(isFreeLimit, userDetail, "userDetail--1");
  const [isPublic, setIsPublic] = useState(true);
  const [link, setLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  let generatedLink = process.env.NEXT_PUBLIC_APP_SITE_WEBSITE_URL;
  const [isGenerateLink, setIsGenerateLink] = useState(false);
  const [isLinkGenerated, setIsLinkGenerated] = useState(false);
  const [isShowGenerateLoading, setIsGenerateLoading] = useState(false);
  const [generateLinkResponse, setGenerateLinkResponse] =
    useState<GenerateLinkResponse | null>(null);
  const [allGeneratedLinkResponse, setAllGeneratedLinkResponse] = useState<
    GenerateLinkResponse[]
  >([]);
  const {isFreeLimit,shareData} = useSelector((state)=>state.main)
  const [isRegenerateLink,setIsRegenerateLink] = useState(false);
  const dispatch = useDispatch()

  // console.log(generateData, "generateData-test-1",shareData);


  // const isFreeLimitBool = isFreeLimit === true || isFreeLimit === "true";

  const [timeLeft, setTimeLeft] = useState("");
  const [hideLinkHistory, setHideLinkHistory] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 2;
  function timeAgo(dateString: string): string {
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 60) return "just now";

    const intervals: Record<string, number> = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
    };

    for (let key in intervals) {
      const interval = Math.floor(seconds / intervals[key]);
      if (interval >= 1) {
        return `${interval} ${key}${interval > 1 ? "s" : ""} ago`;
      }
    }

    // 👇 fallback in case nothing matches
    return "just now";
  }

  // Lock/unlock scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  function copyToClipboard(text: string) {
    const tempInput = document.createElement("textarea");
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    // console.log("Copied:", text);
  }

  if (!open) return null;
  const generateLink = async () => {
    try {
      if (generateLinkResponse?._id) {
        if (generateLinkResponse.status === "disabled") {
          await enabledGeneratedLink(generateLinkResponse._id);
        }
        return;
      }

      const res = await fetch(
        `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/website/generate-public-link`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          cache: "no-store",
          body: JSON.stringify(generateData),
        }
      );

      if (!res.ok) {
        throw new Error(`Failed to generate link: ${res.status}`);
      }

      const json: { data: GenerateLinkResponse } = await res.json();
      setIsGenerateLoading(false);
      setIsLinkGenerated(true);
      setGenerateLinkResponse(json.data);
      setIsPublic(true);
      setTimeout(() => {
        getAllGeneratedLink();
      }, 1000);
      // console.log("✅ Response:", json.data);
    } catch (err) {
      console.error("Error generating link:", err);
    }
  };
  useEffect(() => {
    if (isGenerateLink) {
      generateLink();
    }
  }, [isGenerateLink]);

  const getGeneratedLink = async () => {
    try {
      // console.log("setGenerateLinkResponse-1");
      setGenerateLinkResponse(null);
      setIsLinkGenerated(false);
      setIsGenerateLink(false);

      // const apiUrl = `http://localhost:4700/api/website/get-generated-link?websiteDetailsUid=${generateData.websiteDetailsUid}&screenId=${generateData.screenId}`;
      const apiUrl = `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/website/get-generated-link?websiteDetailsUid=${generateData.websiteDetailsUid}&screenId=${generateData.screenId}`;

      const response = await fetch(apiUrl, {
        method: "GET",
        cache: "no-store", // ✅ हर बार fresh data
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch: ${response.status}`);
      }
      const json = await response.json();
      // console.log("Parsed JSON:", json);

      if (!json?.data) {
        console.warn("⚠️ No generated link found for this screen.");
        return; // safe exit
      }
      const data: GenerateLinkResponse = {
        expiresAt: json.data.expiresAt,
        shareToken: json.data.shareToken,
        _id: json.data._id,
        status: json.data.status,
      };

      // console.log("setGenerateLinkResponse-2", data);
      setGenerateLinkResponse(data);
      if (json.data.status === "active") {
        setIsGenerateLink(true);
        setIsLinkGenerated(true);
      }
    } catch (err) {
      console.error("Server error", err);
    }
  };
  const getAllGeneratedLink = async () => {
    try {
      const apiUrl = `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/website/get-all-generated-link?websiteDetailsUid=${generateData.websiteDetailsUid}&screenId=${generateData.screenId}`;
      const res = await fetch(apiUrl, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        cache: "no-store",
      });

      if (!res.ok) {
        throw new Error(`Failed to fetch all generated links: ${res.status}`);
      }
      const json: { data: GenerateLinkResponse[] | null } = await res.json();
      if (!json.data) return;
      setAllGeneratedLinkResponse(json.data);
    } catch (err) {
      console.error("❌ Error in getAllGeneratedLink:", err);
    }
  };

  const disabledGeneratedLink = async (id: string) => {
    try {
      const apiUrl = `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/website/disable-generate-link?id=${id}`;
      const res = await fetch(apiUrl, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        cache: "no-store",
      });

      if (!res.ok) {
        throw new Error(`Failed to disable link: ${res.status}`);
      }

      const json: { data: GenerateLinkResponse | null } = await res.json();

      if (!json.data) return;

      setIsGenerateLink(false);
      setIsLinkGenerated(false);
      setGenerateLinkResponse(json.data); // ✅ valid or null only
      getAllGeneratedLink();
    } catch (err) {
      console.error("❌ Error in disabledGeneratedLink:", err);
    }
  };
  const enabledGeneratedLink = async (id: string) => {
    try {
      const apiUrl = `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/website/enable-generate-link?id=${id}`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        cache: "no-store",
        body: JSON.stringify({ id }),
      });

      const json: { data?: GenerateLinkResponse } = await response.json();

      if (!json?.data) return;
      setIsLinkGenerated(true);
      setIsGenerateLoading(false);
      setGenerateLinkResponse(json.data);
      setIsPublic(true);
      getAllGeneratedLink();
    } catch (err) {
      console.error("Error enabling generated link:", err);
    }
  };
  const reGeneratedLink = async (id: string) => {
    try {
      if(isRegenerateLink){
        return;
      }
      setIsRegenerateLink(true)
      const apiUrl = `${process.env.NEXT_PUBLIC_APP_URL_LOCAL}/api/website/re-generate-link?id=${id}`;

      const res = await fetch(apiUrl, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        cache: "no-store",
      });

      if (!res.ok) {
        throw new Error(`Failed to re-generate link: ${res.status}`);
      }

      const json: { data: GenerateLinkResponse | null } = await res.json();

      if (!json.data) return;

      setGenerateLinkResponse(json.data);
      getAllGeneratedLink();
      setTimeout(()=>{
        setIsRegenerateLink(false)
      },1000)
    } catch (err) {
      setIsRegenerateLink(false)
      console.error("❌ Error in reGeneratedLink:", err);
    }
  };
  useEffect(() => {
    getGeneratedLink();
  }, [open]);
  useEffect(() => {
    getAllGeneratedLink();
  }, [open]);
  const totalPages = Math.ceil(allGeneratedLinkResponse.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = allGeneratedLinkResponse.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>
      {/* Main Popup */}
      <div className="fixed px-4 inset-0 z-50 flex items-center justify-center bg-[#181818] bg-opacity-60 backdrop-blur-[1px]">
        <div className="w-full max-w-[600px] rounded-2xl border dark:border-white/10 border-black/10 dark:bg-neutral-900 bg-accent shadow-2xl ring-1 ring-black/5">
          {/* Header */}

          <div className="flex items-center justify-between gap-3 p-2 border-b dark:border-white/10 border-black/10">
            <div className="flex items-center gap-3">
              <div className="grid place-content-center size-12 rounded-xl bg-white/[0.03] ring-1 dark:ring-white/10 ring-black/10">
                <svg
                  viewBox="0 0 48 48"
                  className="size-7 dark:text-neutral-200 text-black"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={1.5}
                  aria-hidden="true"
                >
                  {/* globe circle */}
                  <circle cx="24" cy="24" r="14" className="opacity-90" />

                  {/* globe meridian / parallel lines */}
                  <path d="M24 10v28" />
                  <path d="M10 24h28" />
                  <path d="M15 14c4 4 4 16 0 20" className="opacity-60" />
                  <path d="M33 14c-4 4-4 16 0 20" className="opacity-60" />

                  {/* chain/link (angled) */}
                  <path d="M30 18l6-6a4.5 4.5 0 016.36 0 4.5 4.5 0 010 6.36l-6 6" />
                  <path d="M18 30l-6 6a4.5 4.5 0 01-6.36 0 4.5 4.5 0 010-6.36l6-6" />

                  {/* connector between the two links */}
                  <path d="M22 26l4-4" />

                  {/* outward arrow indicating 'share' */}
                  <path d="M34 14l8-8" />
                  <path d="M34 6h8v8" />
                </svg>
              </div>
              <h2 id="modal-title" className="text-xl font-semibold">
                Share Public Link
              </h2>
            </div>
            <button
              id="closeModal"
              // onClick={onClose}
                      onClick={() => {
                              onClose();
                              //  dispatch(setActiveItem("z-[40]"));
                              // dispatch(setActiveNavItem("z-[40]"));
                            }}
              className="rounded-lg p-2 hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30"
            >
              <span className="sr-only">Close</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="size-5"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-6 space-y-5">
            <div className="space-y-4">
              {/* Toggle */}
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-sm font-medium text-gray-900 dark:text-gray-100">
                    Public Link
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Anyone with this link can view
                  </p>
                </div>
                {/* Right side: toggle */}
                <div className="flex items-center h-full">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={isGenerateLink}
                      onChange={(e) => {
                        if (!e.target.checked) {
                          if (generateLinkResponse?._id) {
                            disabledGeneratedLink(generateLinkResponse._id);
                          }
                        } else {
                          console.log(isFreeLimit, "==else========isFreeLimit");
                          if (isFreeLimit) {
                            setShowPaymentModal(true);
                            return;
                          }
                          setIsGenerateLink(e.target.checked);
                          setIsGenerateLoading(true);
                        }
                      }}
                      disabled={loading}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-600 rounded-full peer-checked:bg-green-500 transition-colors duration-300"></div>
                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300 peer-checked:translate-x-5" />
                  </label>
                </div>
              </div>

              {/* Link Display */}
              {isGenerateLink && generateLinkResponse?.shareToken ? (
                <div className="">
                  <div
                    className="border-token-border-medium bg-token-main-surface-primary text-token-text-secondary has-focus-visible:border-token-border-xheavy mb-2 flex items-center justify-between rounded-full border p-1 last:mb-2 sm:p-1"
                    style={{ marginLeft: "-7px" }}
                  >
                    <div className="relative ms-1 grow">
                      <input
                        type="text"
                        value={
                          !isFreeLimit
                            ? `${generatedLink}${generateLinkResponse?.shareToken}`
                            : ""
                        }
                        readOnly
                        className="dark:bg-[#181818] bg-token-main-surface-primary w-full rounded-xl border-0 px-5 py-1 text-sm focus:ring-0 sm:py-2.5 text-token-text-primary"
                      />
                      <div className="from-token-main-surface-primary pointer-events-none absolute end-0 top-0 bottom-0 w-12 bg-linear-to-l"></div>
                    </div>
                    <button
                      className=" dark:bg-white bg-black text-white hover:bg-white hover:text-black dark:text-black dark:hover:bg-accent dark:hover:text-white btn relative btn-primary ms-4 me-0 mt-0 rounded-full px-4 py-1 text-base font-bold sm:py-3"
                      type="button"
                      onClick={() => {
                        copyToClipboard(
                          `${generatedLink}${generateLinkResponse?.shareToken}`
                        );
                        alert("Link Copied!");
                      }}
                    >
                      <div className="flex w-full items-center justify-center gap-1.5 ">
                        Copy link
                      </div>
                    </button>
                  </div>

                  {/* <button
                    onClick={() =>
                      window.open(
                        `${generatedLink}${generateLinkResponse?.shareToken}`,
                        "_blank"
                      )
                    }
                    className="text-gray-700 dark:text-[rgb(228,229,231)] dark:hover:text-white transition"
                  >
                    <ShareIcon size={16} />{" "}
                  </button> */}

                  <div className="flex sm:flex-row flex-col items-center space-x-3 sm:gap-0 gap-1.5">
                    <button
                      onClick={() =>
                        disabledGeneratedLink(generateLinkResponse._id)
                      }
                      className="flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                    >
                      <Ban size={16} />
                      Unpublish
                    </button>
                    <button
                      onClick={() => reGeneratedLink(generateLinkResponse._id)}
                      disabled={isRegenerateLink}
                      className="flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                    >
                      <RefreshCw size={16} />
                      {isRegenerateLink ? 'Please wait...' : 'Regenerate link'}
                    </button>
                    {allGeneratedLinkResponse.length > 0 && (
                      <button
                        id="toggleHistory"
                        className="flex items-center gap-1 text-sm font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 transition-colors"
                        onClick={() => {
                          setHideLinkHistory(!hideLinkHistory);
                        }}
                      >
                        <ClockRewind size={16} />
                        <span>
                          {hideLinkHistory
                            ? "View Public Link History"
                            : "Hide Public Link History"}
                        </span>
                      </button>
                    )}
                  </div>
                </div>
              ) : (
                <div className="rounded-lg p-4 dark:bg-[#181818] bg-white text-center space-y-2  border dark:border-white/10 border-black/10">
                  <p className="text-sm dark:text-gray-400 text-gray-500">
                    No public link created. Enable to generate a permanent
                    shareable link.
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Public Link History Table */}
          {allGeneratedLinkResponse.length > 0 && !hideLinkHistory && (
            <div className="overflow-x-auto">
              <table className="border-t border-[#e3e3e3] dark:border-[#3a3a3a] min-w-full overflow-hidden">
                <thead className="">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase text-gray-700 dark:text-gray-300">
                      Link
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase text-gray-700 dark:text-gray-300">
                      Hits
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-400 uppercase text-gray-700 dark:text-gray-300">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="border-t border-white/10  bg-[#ffffff] dark:bg-[#181818] hover:bg-gray-50">
                  {paginatedData.map((data, index) => (
                    <tr
                      key={data._id ?? index}
                      className="dark:hover:bg-[#181818] transition"
                    >
                      {/* Link */}
                      <td className="px-6 py-3 align-top">
                        <div className="flex flex-col">
                          <span className="text-sm font-medium break-all max-w-xs leading-5 text-gray-900 dark:text-gray-100">
                            {generatedLink}
                            {data?.shareToken}
                          </span>

                          <div className="flex items-center space-x-3 mt-1">
                            {/* Copy */}
                            <button
                              className="text-blue-400 hover:text-blue-300"
                              onClick={() =>
                                copyToClipboard(
                                  `${generatedLink}${data?.shareToken}`
                                )
                              }
                            >
                              <i className="fas fa-copy"></i>
                            </button>
                            {/* Open */}
                            <button
                              className="text-blue-400 hover:text-blue-300"
                              onClick={() =>
                                window.open(
                                  `${generatedLink}${data?.shareToken}`,
                                  "_blank"
                                )
                              }
                            >
                              <i className="fas fa-external-link-alt"></i>
                            </button>
                          </div>

                          {/* Date */}
                          <div className="text-xs text-gray-400 mt-2">
                            <span className=" border border-gray-300 px-2 py-1 rounded text-gray-700 dark:text-gray-300 dark:bg-[#1f1f1f] dark:border dark:border-[#1f1f1f]">
                              {timeAgo(
                                data.createdAt ?? new Date().toISOString()
                              )}
                            </span>
                          </div>
                        </div>
                      </td>

                      {/* Hits */}
                      <td className="px-4 py-3 text-sm font-medium text-gray-900 dark:text-gray-100">
                        {data.noOfHits ?? 0}
                      </td>

                      {/* Status */}
                      <td className="px-6 py-3 text-sm">
                        {data.status === "active" ? (
                          <span className="text-green-400 flex items-center gap-1">
                            <i className="fas fa-check-circle"></i> Active
                          </span>
                        ) : (
                          <span className="text-red-400 flex items-center gap-1">
                            <i className="fa fa-ban"></i> Disabled
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Pagination */}
              <div className="flex flex-col items-center justify-center px-4 py-3 border-t border-[#e3e3e3] dark:border-[#3a3a3a] flex-wrap">
                <div className="text-sm text-gray-400 text-gray-700 dark:text-gray-300 mb-2">
                  Showing <span className="font-medium">{startIndex + 1}</span>{" "}
                  to{" "}
                  <span className="font-medium">
                    {Math.min(
                      startIndex + itemsPerPage,
                      allGeneratedLinkResponse.length
                    )}
                  </span>{" "}
                  of{" "}
                  <span className="font-medium">
                    {allGeneratedLinkResponse.length}
                  </span>{" "}
                  entries
                </div>

                <div className="flex flex-wrap space-x-1">
                  {/* Prev */}
                  <button
                    className="p-1 rounded border bboder-[#e3e3e3] dark:border-[#3a3a3a] bg-[#ffffff] dark:bg-[#2b2b2b] text-gray-400 hover:bg-[#ececec] dark:hover:bg-[#3a3a3a] disabled:opacity-50 text-gray-700 dark:text-gray-300 "
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p) => p - 1)}
                  >
                    <ChevronsLeft />
                  </button>

                  {/* Pages */}
                  {/* {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (page) => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`px-3 py-1 rounded border border-[#e3e3e3] dark:border-[#3a3a3a] ${
                          currentPage === page
                            ? "bg-[#ececec] dark:bg-[#1f1f1f] text-gray-700 dark:text-gray-300"
                            : "bg-[#ffffff] dark:bg-[#2b2b2b] text-gray-300 hover:bg-[#ececec] dark:hover:bg-[#3a3a3a] text-gray-700 dark:text-gray-300"
                        }`}
                      >
                        {page}
                      </button>
                    )
                  )} */}
                  {/* Pages */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter((page) => {
                      if (totalPages <= 5) return true; // show all if few pages
                      if (page === 1 || page === totalPages) return true; // always show first & last
                      if (page >= currentPage - 1 && page <= currentPage + 1)
                        return true; // around current
                      return false;
                    })
                    .flatMap((page, idx, arr) => {
                      const prev = arr[idx - 1];

                      // Insert "..." if there’s a gap
                      if (prev && page - prev > 1) {
                        return [
                          <span key={`dots-${page}`} className="px-2">
                            ...
                          </span>,
                          <button
                            key={page}
                            onClick={() => setCurrentPage(page)}
                            className={`px-3 py-1 rounded border border-[#e3e3e3] dark:border-[#3a3a3a] ${
                              currentPage === page
                                ? "bg-[#ececec] dark:bg-[#1f1f1f] text-gray-700 dark:text-gray-300"
                                : "bg-[#ffffff] dark:bg-[#2b2b2b] hover:bg-[#ececec] dark:hover:bg-[#3a3a3a] text-gray-700 dark:text-gray-300"
                            }`}
                          >
                            {page}
                          </button>,
                        ];
                      }

                      return [
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-3 py-1 rounded border border-[#e3e3e3] dark:border-[#3a3a3a] ${
                            currentPage === page
                              ? "bg-[#ececec] dark:bg-[#1f1f1f] text-gray-700 dark:text-gray-300"
                              : "bg-[#ffffff] dark:bg-[#2b2b2b] hover:bg-[#ececec] dark:hover:bg-[#3a3a3a] text-gray-700 dark:text-gray-300"
                          }`}
                        >
                          {page}
                        </button>,
                      ];
                    })}

                  {/* Next */}
                  <button
                    className="p-1 rounded border boder-[#e3e3e3] dark:border-[#3a3a3a] bg-[#ffffff] dark:bg-[#2b2b2b] text-gray-300 hover:bg-[#ececec] dark:hover:bg-[#3a3a3a] disabled:opacity-50 text-gray-700 dark:text-gray-300"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((p) => p + 1)}
                  >
                    <ChevronsRight />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Buy Credits Modal */}
      {showPaymentModal && userDetail && (
        <BuyCreditsModal
          show={showPaymentModal}
          handleClose={() => setShowPaymentModal(false)}
          userDetail={userDetail}
        />
      )}
    </>
  );
}
